<!-- Wireframe "Open Positions" card (gigsumo-inapp-company-page-Opti.html #panel-jobs).
     The previous header + 'large' cards are unchanged in #legacyJobs below. -->
<ng-container *ngIf="useWireframeJobs; else legacyJobs">
  <div class="bj-card">
    <div class="bj-hd">
      <div class="bj-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
        Open Positions
        <span class="bj-count" *ngIf="totalJobsCount != null">({{totalJobsCount}})</span>
      </div>
      <button *ngIf="canPostJob" type="button" class="bj-post" (click)="postJob()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Post a Job
      </button>
    </div>

    <div class="bj-search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input type="text" placeholder="Search Job Title, Job ID, Skills" aria-label="Search jobs"
        [(ngModel)]="searchContent" #Search (input)="searchfilter(Search.value)" />
      <button *ngIf="searchContent" type="button" class="bj-search-clear" aria-label="Clear search" (click)="clearSearch()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <app-common-skeleton *ngIf="loadAPIcall && response?.length == 0" [countforView]="4"
      [NameOftheScreen]="'jobrowBusiness'"></app-common-skeleton>

    <!-- jobsFoundStatus '' : the empty states are this card's own (below), not app-jobs' #noResult. -->
    <app-jobs [loadAPIcall]="loadAPIcall" [viewSize]="'business-row'" infiniteScroll [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()" [passValues]="response" [jobsFoundStatus]="''"
      [memberPreview]="isMemberPreview" (jobReloadFromJobComponent)="onJobEdited($event)"></app-jobs>

    <app-common-skeleton *ngIf="loadAPIcall && response?.length > 0" [countforView]="2"
      [NameOftheScreen]="'jobrowBusiness'"></app-common-skeleton>

    <div class="bj-empty" *ngIf="!loadAPIcall && response?.length == 0 && noJobsFound">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
      <ng-container *ngIf="searchContent; else noJobsAtAll">
        <div class="bj-empty-title">No jobs match "{{ searchContent }}"</div>
        <button type="button" class="bj-empty-btn bj-empty-btn--outline" (click)="clearSearch()">Clear search</button>
      </ng-container>
      <ng-template #noJobsAtAll>
        <div class="bj-empty-title">No open positions yet</div>
        <ng-container *ngIf="canPostJob; else memberEmpty">
          <div class="bj-empty-sub">Post your first job to start hiring.</div>
          <button type="button" class="bj-empty-btn" (click)="postJob()">Post a Job</button>
        </ng-container>
        <ng-template #memberEmpty>
          <div class="bj-empty-sub">This company hasn't posted any jobs yet.</div>
        </ng-template>
      </ng-template>
    </div>

    <div class="bj-end" *ngIf="stopscrollFlag && response?.length != 0">
      <span class="bj-end-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
      </span>
      <div class="bj-end-title">You've reached the bottom of the page</div>
      <div class="bj-end-sub">That's every open position for now.</div>
    </div>
  </div>
</ng-container>

<ng-template #legacyJobs>
<div class="hpanel">
  <div class="panel-body border-radius-top-left-right-6">
    <div class="headerBusinessJobTitle">
      <!-- <ng-icon name="tablerBriefcase"></ng-icon> -->
      <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
      <h6>Business Jobs</h6>
      <small>({{totalJobsCount}} found)</small>
      <div class="app-form flex-1">
        <div class="pos-rel-10">
          <input class="form-control input-sm pd-lt-10 search-field-pad" placeholder="Search Job Title, Job ID, Skills" type="text"
            [(ngModel)]="searchContent"  #Search (input)="searchfilter(Search.value)"  />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- <div class="col-sm-12"> -->
  <!-- <app-jobs [loadAPIcall]="loadAPIcall" [viewSize]="'medium'" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="300"
    (scrolled)="onScrollDown()" [passValues]="response" [jobsFoundStatus]="jobFoundStatus"
    style="z-index: -1;"></app-jobs> -->
  <!-- <app-job-card [viewSize]="'medium'"  [JobData]="response" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="300"
    (scrolled)="onScrollDown()" [jobsFoundStatus]="jobFoundStatus"
    style="z-index: -1;"></app-job-card> -->
  <!-- <div *ngFor="let item of response">
    <app-job-card [viewSize]="'medium'" [hideActions]="true" [showStatus]="true" [JobData]="item"></app-job-card>
  </div>
  <div *ngIf="stopscrollFlag  && response?.length != 0" class="row caught_up_business">
    <div class="col-md-12 mg-bt-9">
      <ng-icon name="tablerCircleCheck"></ng-icon>
    </div>
    <div class="col-md-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div> -->
<!-- </div> -->

<!-- First-load skeleton replaces app-jobs' "Fetching Jobs..." text; the
     load-more skeleton sits under the list (app-jobs has none for 'large'). -->
<div class="col-12" *ngIf="loadAPIcall && response?.length == 0">
  <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
</div>
<app-jobs [loadAPIcall]="loadAPIcall" [viewSize]="'large'" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="300"
  (scrolled)="onScrollDown()" [passValues]="response"
  [jobsFoundStatus]="loadAPIcall && response?.length == 0 ? '' : jobFoundStatus"
  style="z-index: -1;"></app-jobs>
<app-common-skeleton *ngIf="loadAPIcall && response?.length > 0" [countforView]="2"
  [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
<div *ngIf="stopscrollFlag && response?.length != 0" class="row caught_up_business">
  <div class="col-md-12 mg-bt-9">
    <ng-icon name="tablerCircleCheck"></ng-icon>
  </div>
  <div class="col-md-12">
    <p class="biase">You've reached the bottom of the page</p>
  </div>
</div>
</ng-template>
